module.exports = __webpack_public_path__ + "static/img/5.5d8b9d3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/3/eng/5.png
// module id = VDeq
// module chunks = 0